import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type EditExternalLicenseButtonProps } from "./edit-external-license-button.interface";
import { Paths } from "../../../routes/paths";

export const EditExternalLicenseButton = ({
	externalLicenseId,
}: EditExternalLicenseButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<Button
			icon="pi pi-pencil"
			tooltip={t("externalLicenses.editLicenseTooltip")}
			onClick={() => {
				navigate(Paths.externalLicenses.withId(externalLicenseId).edit.path);
			}}
		/>
	);
};
